import {Component, computed, inject, input} from '@angular/core';
import {Dropdown} from '../dropdown/dropdown';
import {MultiDropdown} from '../multi-dropdown/multi-dropdown';
import {TranslatePipe} from '@ngx-translate/core';
import {UserStore} from '../../features/users/services/user-store';
import {UserSelect} from '../../../api';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'elcia-user-dropdown',
  imports: [
    Dropdown,
    MultiDropdown,
    TranslatePipe,
  ],
  templateUrl: './user-dropdown.html',
  styleUrl: './user-dropdown.scss',
})
export class UserDropdown {

  userStore = inject(UserStore);

  users = computed<UserSelect[]>(() => this.userStore.users());
  control = input.required<FormControl>();
  isMulti = input(false);
  label = input.required<'author' | 'assigned'>();

  labelKey = computed(() => {
    if (this.label() === 'author') {
      return this.isMulti() ? 'app.authors' : 'app.author';
    } else if (this.label() === 'assigned') {
      return 'app.assigned-to';
    }
    return "";
  })

}
